import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import AppBar from '@mui/material/AppBar';

import { TopMenu } from './TopMenu';
import { PageRoute } from '../AppRoutes';

import { BuildVersion } from '../version';
import { Typography } from '@mui/material';

interface LayoutProps {
   topMenu?: PageRoute[]
   title?: string
   subtitle?: string
   children?: any
}

export const Layout = ({ topMenu, title, subtitle, children }: LayoutProps) => {
   return (
      <Container maxWidth={false} sx={{ display: 'flex', margin: 'auto', p: 0, flexDirection: 'column', minHeight: '100vh', maxWidth: '100%' }}>
         <AppBar position='sticky' sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <TopMenu
               pages={topMenu}
               title={title}
               subtitle={subtitle}
            />
         </AppBar>

           <Box id='mainBox' component='main' sx={{ width: { xs: '100%', md: '100%', lg: '90%' }, margin: 'auto', flexGrow: 1, p: 3 }}>
            {children}
         </Box>

         <Box component='footer' minWidth='inherit' alignContent='right' textAlign='right'>
            <Typography variant='body1' color="white" fontWeight='100' sx={{ pr: 10 }} >Build version: {BuildVersion}</Typography>
         </Box>
      </Container>
   );
}

export default Layout;
